module.exports = __webpack_public_path__ + "img/dark-home.21a74a7d.png";